export const MESSAGE_GENERIC_ERROR = 'Something went wrong, please try again.'

export enum MessageProgramControl {
  AccountChangeSuccess = 'Device account number changed',
  AccountChangeFailure = 'Device account number change failed',
  RestartSuccess = 'Device is restarting, this process could take up to 2 minutes',
  RestartFailure = 'Failed to send restart command to device'
}

export const MESSAGE_VALUE_NOT_ASSIGNED = '<None assigned>'
export const MESSAGE_VALUE_NONE = '<None>'

export const MESSAGE_VALUE_NOT_ASSIGNED_ALT = '<No value assigned>'

export const NO_RESULTS_DEFAULT_FILTER_MESSAGE = 'No results found. If you have a filter applied, clear it and try again.'

export const MESSAGE_IS_MM_ADMIN = 'Allows this user to edit site details, controls, users, zones, schedules, triggers, and other settings.';
